import styled from "styled-components";

export const PreviewSubmitSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 16px;
`;

export const ClearButton = styled.button`
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  border-radius: 4px;
  padding: 6px;
  :hover {
    background-color: ${({ theme }) => theme.colors.BLUE_LIGHT};
  }
`;

export const PreviewText = styled.div`
  position: absolute;
  right: 20%;
  font-size: 15px;
  font-weight: bold;
  margin: 24px 0;
  color: red;
`;

export const SubmitButton = styled.button`
  width: 300px;
  padding: 18px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.colors.BLUE_HEAVY};
  color: ${({ theme }) => theme.colors.WHITE};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 auto;
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const CompleteTitle = styled.div`
  border-top: 1px dashed blue;
  padding: 80px 0px 20px 0px;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: -40px;
  width: 620px;

  @media (max-width: 768px) {
    width: calc(100% - 1px);
  }
`;

export const Complete = styled.div`
  font-weight: bold;
  font-size: 24px;
  margin: 24px 0px 0px 0px;

  @media (max-width: 768px) {
    width: calc(100% - 40px);
  }
`;
